function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { renderToBody } from "./render-to-body";
export function renderImperatively(element) {
  var Wrapper = /*#__PURE__*/React.forwardRef(function (_, ref) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];
    var closedRef = useRef(false);
    var _useState3 = useState(element),
      _useState4 = _slicedToArray(_useState3, 2),
      elementToRender = _useState4[0],
      setElementToRender = _useState4[1];
    var keyRef = useRef(0);
    useEffect(function () {
      if (!closedRef.current) {
        setVisible(true);
      } else {
        afterClose();
      }
    }, []);
    function onClose() {
      var _a, _b;
      closedRef.current = true;
      setVisible(false);
      (_b = (_a = elementToRender.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    function afterClose() {
      var _a, _b;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      unmount();
      (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    function onMaskClick() {
      var _a, _b;
      closedRef.current = true;
      if (elementToRender.props.closeOnMaskClick) {
        setVisible(false);
      }
      (_b = (_a = elementToRender.props) === null || _a === void 0 ? void 0 : _a.onMaskClick) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    useImperativeHandle(ref, function () {
      return {
        close: onClose,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        replace: function replace(element) {
          var _a, _b;
          keyRef.current++;
          (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
          setElementToRender(element);
        }
      };
    });
    return /*#__PURE__*/React.cloneElement(elementToRender, Object.assign(Object.assign({}, elementToRender.props), {
      key: keyRef.current,
      visible: visible,
      onClose: onClose,
      afterClose: afterClose,
      onMaskClick: onMaskClick
    }));
  });
  var wrapperRef = /*#__PURE__*/React.createRef();
  var unmount = renderToBody( /*#__PURE__*/React.createElement(Wrapper, {
    ref: wrapperRef
  }));
  return {
    close: function close() {
      var _a;
      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.close();
    },
    // eslint-disable-next-line @typescript-eslint/no-shadow
    replace: function replace(element) {
      var _a;
      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.replace(element);
    }
  };
}